<template>
  <div class="modern-color-theme font-poppins flex flex-col gap-2" data-component-name="VCheckbox">
    <div class="flex gap-x-2 items-center" :class="{ 'pl-2': !props.flipped, 'flex-row-reverse justify-between': props.flipped }">
      <template v-if="props.readonly">
        <input :id="id" :checked="modelValue" type="checkbox" :name="props.name" :disabled="props.disabled" :indeterminate="props.indeterminate" :tabindex="props.tabindex" :aria-describedby="descriptionId" class="h-4 w-4 rounded border-neutral-300 focus:ring-blue-500 text-primary-500 disabled:text-neutral-200" @click.prevent.stop>
      </template>
      <template v-else>
        <input :id="id" v-model="modelValue" type="checkbox" :name="props.name" :disabled="props.disabled" :indeterminate="props.indeterminate" :tabindex="props.tabindex" :aria-describedby="descriptionId" class="h-4 w-4 rounded border-neutral-300 focus:ring-blue-500 text-primary-500 disabled:text-neutral-200 cursor-pointer">
      </template>
      <VSLabel v-if="props.label" :tooltip="props.labelTooltip" :for="id">{{ props.label }}</VSLabel>
    </div>
    <VSDescription v-if="props.description" :id="descriptionId" v-safe-html="props.description" :class="{ 'ml-8': !props.flipped }" />
  </div>
</template>
<script lang="ts" setup>
import VSDescription from './components/VSDescription.vue'
import VSLabel from './components/VSLabel.vue'
import { useElementId, useDescriptionElementId } from '../../utils/utils';
import { SHARED_PROPS_DEFAULTS, type SharedProps } from './helpers/types';

defineOptions({
  name: 'VCheckbox'
})

const props = withDefaults(
  defineProps<SharedProps & {
    tabindex?: number | string
    /**
     * Display checkbox as indeterminate (partially checked)
     */
    indeterminate?: boolean
    /**
     * Invert position of checkbox and text
     */
    flipped?: boolean
  }>(),
  {
    ...SHARED_PROPS_DEFAULTS,
    tabindex: undefined,
    indeterminate: false,
    flipped: false
  }
)

const id = useElementId(props.id)
const descriptionId = useDescriptionElementId(props.description, id.value)

const modelValue = defineModel<boolean | undefined | null>({ required: true })

defineExpose({
  get isValid () {
    // Fake validation value to allow use within VSimpleDialog
    return true
  },
  get isEmpty () {
    // Checkbox has always a value
    return false
  }
})
</script>